export default __webpack_public_path__ + "static/HD_Camera_Alarm_Relay-4ddf27f21a61bca75e6107884f609f18.png";